import {
  AccessIntentEnum,
  convertEnumToNumber,
  ECamType,
  TCameraDevice,
} from '../entities/access-edges.interface';

export const normalizeCameraDevice = (
  cameraDevice: Partial<TCameraDevice> | null | undefined
): TCameraDevice | null => {
  if (!cameraDevice || typeof cameraDevice !== 'object') {
    return null;
  }

  const cameraDeviceRecord = cameraDevice as Record<string, unknown>;
  const rawType = (cameraDevice.Type ?? cameraDeviceRecord['type']) as
    | string
    | number
    | undefined;
  const rawAccessIntent = (cameraDevice.AccessIntent ??
    cameraDeviceRecord['accessIntent']) as string | number | undefined;
  const type = convertEnumToNumber(ECamType, rawType);
  const accessIntent = convertEnumToNumber(AccessIntentEnum, rawAccessIntent);

  const normalizedCameraDevice: TCameraDevice = {
    CameraDeviceId: cameraDevice.CameraDeviceId || undefined,
    EquipmentId: cameraDevice.EquipmentId || undefined,
    AccessIntent:
      typeof accessIntent === 'number'
        ? (accessIntent as AccessIntentEnum)
        : undefined,
    Name: cameraDevice.Name || undefined,
    IsActive: cameraDevice.IsActive ?? undefined,
    Type: typeof type === 'number' ? (type as ECamType) : undefined,
    Ip: cameraDevice.Ip || undefined,
    Login: cameraDevice.Login || undefined,
    Password: cameraDevice.Password || undefined,
    SerialNumber: cameraDevice.SerialNumber || undefined,
    UseVideoStreaming: cameraDevice.UseVideoStreaming ?? undefined,
    RtspPort: cameraDevice.RtspPort ?? undefined,
    TenantId: cameraDevice.TenantId || undefined,
    AddedBy: cameraDevice.AddedBy || undefined,
    AddedOnUtc: cameraDevice.AddedOnUtc || undefined,
    UpdatedBy: cameraDevice.UpdatedBy || undefined,
    UpdatedOnUtc: cameraDevice.UpdatedOnUtc || undefined,
    DeletedBy: cameraDevice.DeletedBy || undefined,
    DeletedOnUtc: cameraDevice.DeletedOnUtc || undefined,
    Index: cameraDevice.Index ?? undefined,
    InstanceId: cameraDevice.InstanceId || undefined,
  };

  const cleanedCameraDevice = Object.fromEntries(
    Object.entries(normalizedCameraDevice).filter(
      ([, value]) => value !== undefined && value !== null
    )
  ) as TCameraDevice;

  if (Object.keys(cleanedCameraDevice).length === 0) {
    return null;
  }

  return cleanedCameraDevice;
};

export const normalizeCameraDevices = (
  cameraDevices: unknown
): TCameraDevice[] => {
  if (!Array.isArray(cameraDevices)) {
    return [];
  }

  return cameraDevices
    .map((cameraDevice) =>
      normalizeCameraDevice(cameraDevice as Partial<TCameraDevice>)
    )
    .filter(
      (cameraDevice): cameraDevice is TCameraDevice => cameraDevice !== null
    );
};
